import { toast } from 'react-toastify';

import { updateToken, setInitialEstablishments, setAllEstablishments, setUuid, handleLoading, handleLogout, setLoginStep, setLoginAttemptToken, setChallengeToken, setAppPermissionEstablishments, setTermsOfUseDate, clearLoginFlow } from './actions';
import { setUserId, setUser, setIsAdminUser, setUserResaleId, setUserRestrictions } from '../../Profile/store/actions';
import { setEstablishmentId, setBusinessInfo, setEstablishments, setEstablishmentTypes } from '../../BusinessInfo/store/actions';
import { setMainUser } from '../../EmployeesRegistration/store/actions';
import { setIsFromRegistration } from '../../../components/Onboarding/store/actions';

import { loadFilters, loadUsersSituation } from '../../../components/Filter/store/thunk';
import { fetchLoginStart, fetchLoginPassword, fetchLoginVerifyCode } from './services';
import { setToken } from '../../../services';

const handleLogin = async (userLogin, history, dispatch) => {
  dispatch(handleLoading(true));

  const {
    name,
    phone,
    email,
    userId,
    resaleId,
    uuid,
    accessToken,
    nfTermsOfUse,
    userRestrictions,
    mainUser,
    profileId,
    isAdminUser
  } = userLogin || {};

  const user = {
    name,
    email
  }

  localStorage.setItem('user', JSON.stringify(user));

  let establishments = [];

  try {
    const data = await dispatch(loadUsersSituation(userId, accessToken));
    establishments = data?.establishments;
    dispatch(setAppPermissionEstablishments(data?.establishments, isAdminUser));
  } catch (error) {
    if(error?.response?.data?.data?.code?.toString() == '01015') {
      dispatch(setUserId(userId));

      return history.push({
        pathname: '/cadastro-inicial',
        state: {
          data: {
            isFromLogin: true
          }
        }
      });
    }
  }

  dispatch(setAllEstablishments(establishments));

  const userData = {
    name,
    phone,
    email
  }

  dispatch(setUser(userData));
  dispatch(setIsAdminUser(isAdminUser));
  dispatch(setMainUser(mainUser));

  const availableEstablishments = establishments;

  let haveEstablishments = false;

  if(establishments.length == 0) {
    haveEstablishments = true;

    localStorage.clear();

    history.push({
      pathname: '/cadastro-inicial',
      state: {
        data: {
          isFromLogin: true
        }
      }
    });

    const establishmentId = availableEstablishments.length == 1 ? availableEstablishments[0].establishmentId : '';

    await setToken(accessToken);
    await dispatch(updateToken(accessToken));
    await dispatch(setTermsOfUseDate(nfTermsOfUse));
    await dispatch(setUserId(userId));
    await dispatch(setUserResaleId(resaleId));
    await dispatch(setUuid(uuid));
    await dispatch(setUserRestrictions(userRestrictions, profileId));
    await dispatch(setInitialEstablishments(availableEstablishments));
    await dispatch(setEstablishmentId({ establishmentId }));
    await dispatch(setEstablishments(availableEstablishments));
    await dispatch(loadFilters(userId));

    if (availableEstablishments.length == 1) {
      await dispatch(setBusinessInfo(availableEstablishments[0]));
    }

    return;
  }

  const establishmentId = availableEstablishments.length == 1 ? availableEstablishments[0].establishmentId : '';

  await setToken(accessToken);
  await dispatch(updateToken(accessToken));
  await dispatch(setTermsOfUseDate(nfTermsOfUse));
  await dispatch(setUserId(userId));
  await dispatch(setUserResaleId(resaleId));
  await dispatch(setUuid(uuid));
  await dispatch(setUserRestrictions(userRestrictions, profileId));
  await dispatch(setInitialEstablishments(availableEstablishments));
  await dispatch(setEstablishmentId({ establishmentId }));
  await dispatch(setEstablishments(availableEstablishments));
  await dispatch(loadFilters(userId));

  if(availableEstablishments.length == 1) {
    await dispatch(setBusinessInfo(availableEstablishments[0]));
    await dispatch(setEstablishmentTypes(availableEstablishments[0]?.establishmentTypes));
  }

  if(availableEstablishments.length == 0 && !haveEstablishments) {
    toast.error('Acesso desativado. Por favor, entre em contato com o financeiro da Jump.');
    return;
  }

  dispatch(setIsFromRegistration(false));
  dispatch(clearLoginFlow());

  if(window.location.pathname == '/termos-nota-fiscal') {
    return history.push('/configuracoes-de-notas-fiscais');
  }

  if(window.location.pathname == '/area-cliente') {
    return history.push('/suas-assinaturas');
  }

  if(window.location.pathname == '/cadastro-cartao') {
    return history.push({
      pathname: '/suas-assinaturas',
      state: {
        data: {
          isFromLogin: true
        }
      }
    });
  }

  history.push('/visao-geral');
}

export const loginStart = (email, turnstileToken) => dispatch => {
  return fetchLoginStart(email, turnstileToken)
    .then(({ data }) => {
      const { next, loginAttemptToken } = data || {};

      dispatch(setLoginStep(next));
      dispatch(setLoginAttemptToken(loginAttemptToken))

      toast.success('E-mail confirmado. Agora digite sua senha!');

      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    });
}

export const loginPassword = (loginAttemptToken, password, history)  => dispatch => {
  return fetchLoginPassword(loginAttemptToken, password)
    .then(async ({ data }) => {
      const { next, challengeToken } = data || {};

      if(data?.next == 'login') {
        await handleLogin(data?.user, history, dispatch);
        return;
      }

      dispatch(setLoginStep(next));
      dispatch(setChallengeToken(challengeToken));

      toast.success('Um código de verificação foi enviado para o seu email!');

      return Promise.resolve();
    })
    .catch(async error => {
      const { code, userId, accessToken } = error?.response?.data?.data || {};
      const noAccessCode = '01037';

      if(code?.toString() == noAccessCode) {
        await setToken(accessToken);
        await dispatch(updateToken(accessToken));
        await dispatch(setUserId(userId));

        return history?.push({
          pathname: '/suas-assinaturas',
          state: {
            data: {
              userId,
              token: accessToken,
              noAccessCode: true
            }
          }
        });
      }

      if(code?.toString() == '01022' || code?.toString() == '01023') {
        dispatch(handleLogout());
        toast.error('Token expirado. Faça login novamente.');
      }

      return Promise.reject();
    });
}

export const loginVerifyCode = (challengeToken, code, history)  => dispatch => {
  dispatch(handleLoading(true));

  return fetchLoginVerifyCode(challengeToken, code)
    .then(async ({ data }) => {
      if(data?.next == 'login') {
        await handleLogin(data?.user, history, dispatch);
      }
    })
    .catch(async error => {
      dispatch(handleLoading(false));

      const { code, userId, accessToken } = error?.response?.data?.data || {};
      const noAccessCode = '01037';

      if(code?.toString() == '01022' || code?.toString() == '01023') {
        dispatch(handleLogout());
        toast.error('Token expirado. Faça login novamente.');
      }

      if(code?.toString() == noAccessCode) {
        await setToken(accessToken);
        await dispatch(updateToken(accessToken));
        await dispatch(setUserId(userId));

        return history?.push({
          pathname: '/suas-assinaturas',
          state: {
            data: {
              userId,
              token: accessToken,
              noAccessCode: true
            }
          }
        });
      }
    })
    .finally(() => dispatch(handleLoading(false)));
}